// getTestApi 호출
import { getTestApi } from '@/api/sys/product';
import { computed } from 'vue';
import store from '@/store';

const appLoading = computed(() => {
	return store.getters['app/appLoading'];
});

interface ProductState {
	testData: any | null;
}
export default {
	namespaced: true,
	state: {
		testData: null, // testApi의 응답을 저장할 state
	},
	getters: {
		// 2. Getter에 타입을 지정합니다.
		testData: (state: ProductState) => state.testData,
	},
	mutations: {
		// 3. Mutation에 타입을 지정합니다.
		setTestData(state: ProductState, data: any) {
			state.testData = data;
		},
	},
	actions: {
		// 4. Action에 타입을 지정합니다.
		async fetchTestData(
			{ commit, state }: { commit: any; state: ProductState },
			payload: any,
		) {
			if (appLoading.value) {
				return;
			} else {
				store.commit('app/UPDATE_LOADING', true);
			}

			try {
				const res = await getTestApi(payload);

				if (res.status === 200) {
					commit('setTestData', res.data);
				}
			} catch (e: any) {
				if (e.response && e.response.status === 401) {
					store.commit('app/RESET_INFO');
				}
				commit('setTestData', null);
			} finally {
				store.commit('app/UPDATE_LOADING', false);
			}
		},
	},
};
